import {EnumDict} from "../core/Reflection";
import {LevelNumber} from "./LevelModel";
import {Location} from "./Location";

export interface LocationCardType {
    location: Location;
    index: number;
    level: LevelNumber;
    distractor?: boolean;
    freePlay?: boolean;
}

export type CardNumber = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
export const MinCardNumber = 1;
export const MaxCardNumber = 8;

const excludedCards: EnumDict<Location, [number, number]> = {
    [Location.Rio]: [3, 8],
    [Location.Nairobi]: [8, 3],
    [Location.Munich]: [7, 3],
    [Location.Beijing]: [5, 3],
    [Location.Cusco]: [6, 4],
    [Location.Tokyo]: [3, 1],
};

export function isCardExcluded(location: Location, level: LevelNumber, card: CardNumber) {
    return excludedCards[location][level - 1] === card;
}
